import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/utils/cn";

const ROWS: { isModule: boolean }[] = [
  { isModule: true },
  { isModule: false },
  { isModule: false },
  { isModule: true },
  { isModule: false },
];

export const SearchLoadingSkeleton = () => (
  <div className="space-y-0.5 p-2">
    {ROWS.map(({ isModule }, i) => (
      <div key={i} className="flex items-center gap-3 px-2 py-2">
        <Skeleton className={cn("shrink-0 rounded-sxs", isModule ? "size-8" : "size-7")} />
        <div className="flex flex-1 flex-col gap-1.5">
          {!isModule && <Skeleton className="h-2.5 w-14" />}
          <Skeleton className={cn("h-4", isModule ? "w-36" : "w-28")} />
        </div>
        <Skeleton className="h-3 w-14 shrink-0" />
      </div>
    ))}
  </div>
);
